import React from "react";
import { formatDateInUSFormatByDate } from "../../../utils/utils";
import { Note, NotesListProps } from "../../../types/types";


const NotesList: React.FC<NotesListProps> = ({ notes,isSideBar,isRightSideBar , heightClass=""}) => {
  function sortNotesByDateDesc(notesArr: Note[]): Note[] {
    return notesArr.sort((a, b) => {
      const dateA = new Date(a.date).getTime();
      const dateB = new Date(b.date).getTime();
      return dateB - dateA; // descending
    });
  }
  return (
    <div className={` ${heightClass}
    space-y-3 mt-1 overflow-y-auto
    ${isRightSideBar
      ? "h-[calc(100vh-180px)]"
      : isSideBar
      ? "h-[320px] md:h-[400px] lg:h-[480px]"
      : "h-[135px] "}
  `}>
      {sortNotesByDateDesc(notes).map((note, index) => (
        <div key={index} className="border-l-4 border-gray-300 pl-4">
          <p className="text-xs text-gray-500">
            {formatDateInUSFormatByDate(new Date(note.date))} by {note?.username ?? "admin"}
          </p>

          <div  dangerouslySetInnerHTML={{ __html: note.noteText }} className="bg-gray-50 rounded-md p-1 text-xs text-gray-800 whitespace-pre-line">
          </div>
        </div>
      ))}
    </div>
  );
};

export default NotesList;
